/* Лендинг-секции коллекций: ревилы, лента материалов, свёртка SEO-текста.
   Подключается каждой секцией — инициализация одноразовая на весь документ. */
(function () {
  if (window.__tmLanding) return;
  window.__tmLanding = true;
  document.documentElement.classList.add('tm-landing-js');

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp01 = function (v) { return Math.max(0, Math.min(1, v)); };

  var ready = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  ready(function () {
    /* --- появление блоков при скролле --- */
    var revEls = document.querySelectorAll('[data-lrev]');
    /* после отыгрыша ревила атрибут снимается: правило .tm-landing-js [data-lrev].is-in
       (transform: none, специфичность выше) иначе навсегда глушит :hover-подъём кнопок
       (chero__btn, fbento__btn), а ревильный transition вытесняет их box-shadow-анимацию.
       1400мс = максимум задержки (.32s) + длительность (.7s) с запасом */
    var revDone = function (el) { el.removeAttribute('data-lrev'); };
    if (reduced || !('IntersectionObserver' in window)) {
      revEls.forEach(function (el) { el.classList.add('is-in'); revDone(el); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          setTimeout(function () { revDone(e.target); }, 1400);
          io.unobserve(e.target);
        });
      }, { threshold: 0.18 });
      revEls.forEach(function (el) { io.observe(el); });
    }

    /* --- лента материалов: вертикальный скролл → горизонтальный проезд --- */
    var strips = [].slice.call(document.querySelectorAll('[data-mstrip]'));
    var updStrips = function () {
      strips.forEach(function (sec) {
        var pin = sec.querySelector('[data-mstrip-pin]');
        var track = sec.querySelector('[data-mstrip-track]');
        if (!pin || !track) return;
        if (getComputedStyle(pin).position !== 'sticky') { track.style.transform = ''; return; }
        var r = sec.getBoundingClientRect();
        var span = r.height - innerHeight;
        var p = span > 0 ? clamp01(-r.top / span) : 0;
        var max = Math.max(0, track.scrollWidth - track.parentElement.clientWidth);
        track.style.transform = 'translateX(' + (-p * max) + 'px)';
        var bar = sec.querySelector('[data-mstrip-bar]');
        if (bar) bar.style.width = (p * 100) + '%';
        var cards = [].slice.call(track.children);
        var active = Math.min(cards.length - 1, Math.floor(p * cards.length));
        var idx = sec.querySelector('[data-mstrip-idx]');
        if (idx) idx.textContent = String(active + 1).padStart(2, '0');
        cards.forEach(function (c, i) { c.classList.toggle('is-active', i === active); });
      });
    };
    if (strips.length) {
      addEventListener('scroll', updStrips, { passive: true });
      addEventListener('resize', updStrips);
      updStrips();
    }

    /* --- статья блога: оглавление из h2 + скроллспай + прогресс чтения --- */
    var artBody = document.querySelector('[data-art-body]');
    if (artBody) {
      var toc = document.querySelector('[data-art-toc]');
      var tocList = document.querySelector('[data-art-toc-list]');
      var heads = [].slice.call(artBody.querySelectorAll('h2'));
      var tocLinks = [];
      if (toc && tocList && heads.length >= 2) {
        heads.forEach(function (h, i) {
          if (!h.id) h.id = 'sec-' + (i + 1);
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          li.appendChild(a);
          tocList.appendChild(li);
          tocLinks.push(a);
        });
        toc.hidden = false;
      }
      var bar = document.querySelector('[data-art-progress]');
      var spy = function () {
        var r = artBody.getBoundingClientRect();
        if (bar && r.height) {
          var p = clamp01((innerHeight * 0.6 - r.top) / r.height);
          bar.style.width = (p * 100) + '%';
        }
        if (tocLinks.length) {
          var current = -1;
          heads.forEach(function (h, i) {
            if (h.getBoundingClientRect().top <= innerHeight * 0.35) current = i;
          });
          tocLinks.forEach(function (a, i) { a.classList.toggle('is-active', i === current); });
        }
      };
      addEventListener('scroll', spy, { passive: true });
      addEventListener('resize', spy);
      spy();
    }

    /* --- свёртка SEO-текста --- */
    document.querySelectorAll('[data-cstory-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-cstory]');
        if (!card) return;
        var open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var more = btn.querySelector('[data-more]');
        var less = btn.querySelector('[data-less]');
        if (more) more.hidden = open;
        if (less) less.hidden = !open;
        if (!open && !reduced) card.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    });
  });
})();
